import React, { useContext, useEffect, useState } from "react";
import TaxRegimesContext from "./context";
import CompanyContext from "../CompanyWrapper/context";

// TODO: wire this with upcoming backend functionality
const taxRegimesConfigByCountry = {
  ES: ["general", "basque", "biscayan", "navarrese"],
  PT: ["general"],
};

export default function TaxRegimesWrapper(props: any) {
  const [isLoading, setIsLoading] = useState(true);
  const [taxRegimes, setTaxRegimes] = useState<string[]>([]);

  const { company } = useContext(CompanyContext);

  useEffect(() => {
    if (company.countryISO2Code in taxRegimesConfigByCountry) {
      setTaxRegimes(taxRegimesConfigByCountry[company.countryISO2Code]);
    }
  }, [setTaxRegimes, company]);

  return (
    <TaxRegimesContext.Provider
      value={{ taxRegimes, setTaxRegimes, isLoading, setIsLoading }}
      {...props}
    />
  );
}
